@let bot = config().bot;
@let currentMessage = message();
@let isBot = currentMessage.isBot;

<div
    class="flex items-center"
    [class]="{
        'justify-end': !isBot,
    }">
    @if (isBot) {
        <div class="self-start p-2 mr-4 leading-none bg-white rounded-full">
            <big-icon
                [icon]="iconChatBot"
                [size]="'w-4'"
                class="fill-primary" />
        </div>
    }
    @if (!isBot && currentMessage.error) {
        <div class="mr-4">
            <button
                (click)="onErrorButtonClick(currentMessage)"
                class="p-0"
                type="button"
                [title]="bot?.status?.error">
                <span class="sr-only">{{ bot?.status?.error }}</span>
                <big-icon
                    [icon]="iconHint"
                    [size]="'w-4'"
                    class="fill-danger-600" />
            </button>
        </div>
    }
    @if (!isBot && currentMessage.isPending) {
        <big-ui-spinner
            size="s"
            spinnerClass="inline-block mr-4">
            <span class="sr-only">{{ bot?.status?.sending }}</span>
        </big-ui-spinner>
    }
    <div class="flex-1">
        @if (currentMessage.text) {
            <div
                [innerHTML]="currentMessage.text | sanitize: securityContext.HTML"
                class="p-4 message rounded-b-md"
                [class]="{
                    'bg-primary': isBot,
                    'text-white': isBot,
                    'rounded-r-md': isBot,
                    'bg-white': !isBot,
                    'rounded-l-md': !isBot,
                }"></div>
        }
        @if (getImage()) {
            <a
                [href]="currentMessage.image"
                target="_blank">
                <img
                    [src]="getImage()"
                    class="img-fluid"
                    alt="" />
            </a>
        }
        @if (getVideo()) {
            <iframe
                [src]="getVideo() | sanitize: securityContext.RESOURCE_URL"
                class="w-full"
                allow="autoplay; encrypted-media"
                allowfullscreen></iframe>
        }
        @if (currentMessage?.buttons?.length) {
            <div class="flex flex-wrap space-x-2 space-y-2 mt-2">
                @for (button of currentMessage.buttons; track $index) {
                    <big-ui-button
                            class="flex-shrink-0"
                            [buttonStyle]="'primary px-5 py-1'"
                            (clicked)="onButtonClick(button)">
                        <span>{{ button.title }}</span>
                    </big-ui-button>
                }
            </div>
        }
    </div>
</div>
